import { registerHandler } from "@utils/pixels/handler";

declare const roktLauncher: any;

export default function registerHandlers() {
  registerHandler("purchase", async ({ emailHashes, order, plan }) => {
    let conversionType = "Free";
    const {
      has_trial,
      trial_duration,
      userSelectedTrialFee,
      discounted_plan_price,
    } = plan;
    if (!has_trial || trial_duration < 1 || userSelectedTrialFee > 0) {
      conversionType = "Paid";
    }

    const pixelData = {
      emailsha256: emailHashes.sha256,
      amount: order?.eltv_13_months || discounted_plan_price || 0,
      currency: plan.currency ? plan.currency : "USD",
      confirmationref: order.subscriptionId,
      conversiontype: conversionType,
    };
    if (roktLauncher) {
      roktLauncher.selectPlacements({
        attributes: pixelData,
      });
    }
  });
}
